/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ buildHash: NonNullable<unknown>, builtAt: NonNullable<unknown> }} About_BuildInputs */

const fr_about_build = /** @type {(inputs: About_BuildInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Build ${i?.buildHash} du ${i?.builtAt}.`)
};

const en_about_build = /** @type {(inputs: About_BuildInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Build ${i?.buildHash} from ${i?.builtAt}.`)
};

/**
* | output |
* | --- |
* | "Build {buildHash} from {builtAt}." |
*
* @param {About_BuildInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const about_build = /** @type {((inputs: About_BuildInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_BuildInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_about_build(inputs)
	return en_about_build(inputs)
});